module.exports = __webpack_public_path__ + "img/showcase-android.09503651.png";